import { DailyRoomNameScope, SessionScope } from '@web-app/atoms/scopes';
import { CallPageRootV2 } from '@web-app/components/CallV2/CallPageRootV2/CallPageRootV2';
import { CallState } from '@web-app/hocs/daily/types';
import { ScopeProvider } from 'bunshi/react';
import { useRouter } from 'next/router';
import { FC } from 'react';

const CallEntryPage: FC<{ predefinedCallState?: CallState }> = ({
  predefinedCallState,
}) => {
  const router = useRouter();
  const roomId =
    typeof router.query.roomId === 'string' ? router.query.roomId : undefined;

  return (
    <ScopeProvider scope={DailyRoomNameScope} value={roomId}>
      <ScopeProvider scope={SessionScope} value={roomId}>
        <CallPageRootV2 predefinedCallState={predefinedCallState} />
      </ScopeProvider>
    </ScopeProvider>
  );
};

export default CallEntryPage;
